import { render, staticRenderFns } from "./scenicList.vue?vue&type=template&id=72a99ef3&scoped=true&"
import script from "./scenicList.vue?vue&type=script&lang=js&"
export * from "./scenicList.vue?vue&type=script&lang=js&"
import style0 from "./scenicList.vue?vue&type=style&index=0&id=72a99ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a99ef3",
  null
  
)

export default component.exports